var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailVerfication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#FDE7E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4545 49.1818C21.0424 49.1818 20.6967 49.0422 20.4175 48.7629C20.1382 48.4836 19.999 48.1384 20 47.7273C20 47.3151 20.1396 46.9695 20.4189 46.6902C20.6982 46.4109 21.0434 46.2718 21.4545 46.2727H50.5454C50.9576 46.2727 51.3033 46.4124 51.5825 46.6916C51.8618 46.9709 52.001 47.3161 52 47.7273C52 48.1394 51.8604 48.4851 51.5811 48.7644C51.3018 49.0436 50.9566 49.1828 50.5454 49.1818H21.4545ZM24.3636 44.8182C23.5636 44.8182 22.8785 44.5331 22.3084 43.9629C21.7382 43.3927 21.4536 42.7081 21.4545 41.9091V25.9091C21.4545 25.1091 21.7396 24.424 22.3098 23.8538C22.88 23.2836 23.5646 22.999 24.3636 23H47.6364C48.4364 23 49.1214 23.2851 49.6916 23.8553C50.2618 24.4255 50.5464 25.1101 50.5454 25.9091V41.9091C50.5454 42.7091 50.2604 43.3942 49.6902 43.9644C49.12 44.5345 48.4354 44.8191 47.6364 44.8182H24.3636ZM24.3636 41.9091H47.6364V25.9091H24.3636V41.9091Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerfication);
export default __webpack_public_path__ + "static/media/emailVerfication.aa68403b7b2e80e3dd9f19e6cb33484e.svg";
export { ForwardRef as ReactComponent };